<template lang="pug">
  v-dialog(
    :content-class="contentClass"
    :eager="eager"
    :persistent="persistent"
    :scrollable="scrollable"
    :max-width="maxWidth"
    :value="lazyValue"
  )
    v-card(v-bind="$attrs")
      v-app-bar(dark dense text :color="color")
        v-toolbar-title.white--text
          slot(name="dialog-title")
            | {{ title }}
        v-spacer
        v-btn(v-if="!disableCloseButton" text icon @click.native="close" :data-test-id="DetailDialogTestIds.CLOSE_DIALOG_BUTTON")
          v-icon close
      v-card-text.dialog-content(ref="dialogCardTextRef")
        slot(name="dialog-content")
      v-card-actions.pt-0.dialog-actions
        v-spacer
        slot(name="dialog-actions")
</template>

<script>
import { ref } from 'vue';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { DetailDialogTestIds } from './constants';

export default {
  name: 'Dialog',
  props: {
    contentClass: {
      type: String,
      required: false,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 'none',
    },
    eager: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'default',
    },
    title: {
      type: String,
      default: '',
    },
    disableCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const dialogCardTextRef = ref(null);
    const { lazyValue } = useModelAutoBinding(emit, props, false);

    const close = () => {
      emit('close');
    };

    const scrollTop = () => {
      if (dialogCardTextRef.value) {
        dialogCardTextRef.value.scrollTop = 0;
      }
    };

    return {
      dialogCardTextRef,
      lazyValue,
      DetailDialogTestIds,
      close,
      scrollTop,
    };
  },
};
</script>
